module.exports = __webpack_public_path__ + "static/abanda-5754da6e24e774df75031a693530ad1c.png";